import { useParams } from "react-router-dom";
import { useMail } from "contexts/mailContext/mailContext.js";

const useSelfRemovalLink = () => {
  const { anotherParam } = useParams();
  const { getDeleteParam, getMailStatus } = useMail();
  if (anotherParam === "delete" || getDeleteParam()) {
    return true;
  } else {
    return false;
  }
};

export default useSelfRemovalLink;
